<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-expansion-panels
          multiple
          v-model="channelPanelOpen"
        >
          <v-expansion-panel v-for="(uart, i) in uarts" :key="i">
            <v-expansion-panel-header>
              Channel:
              {{ uart.channel ? uart.channel.name : '-'}} ({{ uart.label }})
            </v-expansion-panel-header>
            <v-expansion-panel-content eager>
              <div v-if="uart.vbusData">
                <div v-if="uart.vbusData.packets.length > 0">
                  Pakete:
                </div>
                <v-expansion-panels
                  multiple
                  v-model="packetPanelOpen[i]"
                >
                <v-expansion-panel v-for="(packet, j) in parsePackets(uart)" :key="j">
                    <v-expansion-panel-header v-if="packet.packetSpec">
                      {{
                        `${packet.packetSpec.packetId}`
                      }}: {{ packet.packetSpec.sourceDevice.fullName }} to {{ packet.packetSpec.destinationDevice.fullName }}

                    </v-expansion-panel-header>
                    <v-expansion-panel-content eager>
                      <v-container>
                        <v-row class="ml-2">
                          Raw-Buffer: {{ packet.frameData.slice(0, packet.frameCount * 4).toString('hex') }}
                        </v-row>
                        <v-row
                          v-for="(field) in packet.fields" :key="`${field.packetId}_${field.fieldId}`"
                          class="ml-8" dense
                        >
                          <v-col cols="4">
                            {{ field.name }}
                          </v-col>
                          <v-col cols="2">
                            {{ field.value }} {{ field.unit }}
                          </v-col>
                          <v-col cols="6">
                            {{ `${field.packetId}_${field.fieldId}` }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <div v-if="uart.vbusData.datagrams.length > 0">
                  Datagrame:
                </div>
                <ul>
                  <li
                    v-for="(datagram, j) in uart.vbusData.datagrams" :key="j"
                    style="list-style: none;"
                  >
                    {{
                      `${
                        i.toString(16).toUpperCase().padStart(2, '0')
                      }_${
                        datagram.destinationAddress.toString(16).toUpperCase().padStart(4, '0')
                      }_${
                        datagram.sourceAddress.toString(16).toUpperCase().padStart(4, '0')
                      }_${
                        datagram.protocolVersion.toString(16).toUpperCase().padStart(2, '0')
                      }_${
                        datagram.command.toString(16).toUpperCase().padStart(4, '0')
                      }`
                    }} =>
                    0x{{ datagram.valueId.toString(16).padStart(4, '0') }} =
                    {{ datagram.value || 0 }}
                  </li>
                </ul>
                <div v-if="uart.vbusData.telegrams.length > 0">
                  Telegrame:
                </div>
                <ul>
                  <li
                    v-for="(telegram, j) in uart.vbusData.telegrams" :key="j"
                    style="list-style: none;"
                  >
                    {{
                      `${
                        i.toString(16).toUpperCase().padStart(2, '0')
                      }_${
                        telegram.destinationAddress.toString(16).toUpperCase().padStart(4, '0')
                      }_${
                        telegram.sourceAddress.toString(16).toUpperCase().padStart(4, '0')
                      }_${
                        telegram.protocolVersion.toString(16).toUpperCase().padStart(2, '0')
                      }_${
                        telegram.command.toString(16).toUpperCase().padStart(2, '0')
                      }`
                    }} =>
                    {{ telegram.frameData.slice(0, telegram.frameCount * 7).toString('hex') }}
                  </li>
                </ul>
              </div>
              <div v-else-if="uart.rpcData">
                <v-container fluid>
                  <v-row dense>
                    <v-col>ID</v-col>
                    <v-col>Method</v-col>
                    <v-col>Error</v-col>
                    <v-col cols="9">Data</v-col>
                  </v-row>
                  <v-row v-for="(message, j) in uart.rpcData.messages" :key="j" dense>
                    <v-col>{{ message.id }}</v-col>
                    <v-col>{{ message.method != null ? message.method : ' ' }}</v-col>
                    <v-col>{{ message.method == null ? message.error : ' ' }}</v-col>
                    <v-col cols="9">{{ message.result ? message.result.toString('hex') : '' }}</v-col>
                  </v-row>
                </v-container>
              </div>
              <div v-else-if="uart.channel">
                {{ uart.channel.rxBuffer.toString('hex') }}
              </div>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { formatTime, } from '@/utils';
const Packet = require('resol-vbus/src/packet');

export default {
  props: [
    'bridge',
    'uarts',
    'vbusSpecifications',
  ],

  data: () => ({
    channelPanelOpen: [],
    packetPanelOpen: [],
  }),

  methods: {
    formatTime(date) {
      return formatTime(date, true);
    },
    parsePackets(uart) {
      const packets = [];
      uart.vbusData.packets.forEach((packetOptions) => {
        const fields = [];
        let packetSpec = null;
        if (!this.vbusSpecifications || this.vbusSpecifications.length === 0) {
          return fields;
        }
        const packet = new Packet(packetOptions);
        if (packet.destinationAddress === 0x0015) {
          const spec = this.vbusSpecifications[0];
          const blockTypeSections = spec.getBlockTypeSectionsForHeaders([packet]);
          blockTypeSections.forEach((bts) => {
            const blockTypeFields = spec.getBlockTypeFieldsForSections([bts]);
            blockTypeFields.forEach((field) => {
              if (!packetSpec) {
                packetSpec = field.packetSpec;
              }
              let unitString = '';
              if (field.packetFieldSpec.type && field.packetFieldSpec.type.unit && field.packetFieldSpec.type.unit.unitText && field.packetFieldSpec.type.unit.unitText !== '') {
                unitString = field.packetFieldSpec.type.unit.unitText;
              }
              let nameString = '';
              if (typeof field.packetFieldSpec.name.de === 'string') {
                nameString = field.packetFieldSpec.name.de;
              } else {
                nameString = field.name;
              }
              if (field.rawValue !== null) {
                fields.push({
                  packetId: field.packetSpec.packetId,
                  fieldId: field.packetFieldSpec.fieldId,
                  name: nameString,
                  value: field.formatTextValue('None'),
                  unit: unitString,
                });
              }
            });
          });
        } else {
          const spec = this.vbusSpecifications.find((spec) => {
            return spec.getPacketSpecification(packet);
          });
          if (spec) {
            const packetFields = spec.getPacketFieldsForHeaders([packet]);
            packetFields.forEach((field) => {
              if (!packetSpec) {
                packetSpec = field.packetSpec;
              }
              let unitString = '';
              if (field.packetFieldSpec.type && field.packetFieldSpec.type.unit && field.packetFieldSpec.type.unit.unitText && field.packetFieldSpec.type.unit.unitText !== '') {
                unitString = field.packetFieldSpec.type.unit.unitText;
              }
              let nameString = '';
              if (typeof field.packetFieldSpec.name.de === 'string') {
                nameString = field.packetFieldSpec.name.de;
              } else {
                nameString = field.name;
              }
              if (field.rawValue !== null) {
                fields.push({
                  packetId: field.packetSpec.packetId,
                  fieldId: field.packetFieldSpec.fieldId,
                  name: nameString,
                  value: field.formatTextValue('None'),
                  unit: unitString,
                });
              }
            });
          }
        }
        packets.push({ packetSpec, fields, frameData: packetOptions.frameData, frameCount: packet.frameCount, });
      });
      return packets;
    },
  },

  created() {
  },
};

</script>

<style>

</style>
